const USUARIO_PERFIL = {
  cs: { id: "cs", descricao: "Consulta", prioridade: 9 }, // Apenas visualizar
  us: { id: "us", descricao: "Usuário Padrão", prioridade: 6 }, // Visualizar e gerar relatórios
  op: { id: "op", descricao: "Operador", prioridade: 4 }, // Visualizar, gerar e configurar relatórios
  ad: { id: "ad", descricao: "Administrador", prioridade: 2 }, // Visualizar, gerar, assinar, configurar relatórios e entidade
  sp: { id: "sp", descricao: "Super usuário", prioridade: 0 }, // Permissões e acesso total
};

export default USUARIO_PERFIL;
